import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SiteLayout from "@/components/feature/SiteLayout";
import ForecastList from "@/pages/forecast/page";
import ForecastDetail from "@/pages/forecast-detail/page";
import Topics from "@/pages/topics/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "forecast",
        element: <ForecastList />,
      },
      {
        path: "forecast/:id",
        element: <ForecastDetail />,
      },
      {
        path: "topics",
        element: <Topics />,
      },
      {
        path: "about",
        element: <About />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;